import { SVGProps, ReactNode } from 'react';
import {
  PageHeaderTitle,
  PageHeaderTitleProps,
} from '../../atoms/pageHeaderTitle/pageHeaderTitle';

import { PageHeaderSpec } from '../../atoms/pageHeaderSpec/pageHeaderSpec';
import { BreadcrumbProps } from '../../atoms/breadcrumb/breadcrumb';
import { Breadcrumbs } from '../breadcrumbs/breadcrumbs';
import { TextButton } from '../../atoms/textButton/text-button';
import { IconAngleLeft } from '@maia/icons';
import { twMerge } from 'tailwind-merge';
import { LinkProps } from '@tanstack/react-router';
import { TextButtonLink } from '../../atoms/textButton/link-text-button';

type Props = {
  actions?: ReactNode;
  status?: ReactNode;
  specs?: Array<{
    text: string;
    value?: string;
    icon?: (props: SVGProps<SVGSVGElement>) => ReactNode;
  }>;
  breadcrumbs?: Array<BreadcrumbProps>;
  backLink?: LinkProps;
  isSticky?: boolean;
} & PageHeaderTitleProps;

export function PageHeader(props: Props) {
  const {
    icon: Icon,
    title,
    actions,
    specs,
    reference,
    status,
    description,
    breadcrumbs,
    backLink,
    className,
    isSticky = false,
    isSpecialLimit = false,
    ...rest
  } = props;

  return (
    <div
      className={twMerge(
        'flex flex-col space-y-12 px-32 pt-32 pb-24 bg-grayscale0',
        isSticky && 'sticky top-[--toolbar-height] z-10',
        className,
      )}
      {...rest}
    >
      {backLink && title && (
        <TextButtonLink
          to={backLink.to}
          params={backLink.params}
          search={backLink.search}
          intent="standard"
          size="tiny"
          iconLeft={IconAngleLeft}
        >
          Terug
        </TextButtonLink>
      )}

      {breadcrumbs && <Breadcrumbs crumbs={breadcrumbs} />}

      <div className="flex justify-between items-center space-x-48">
        {!title && backLink ? (
          <TextButton
            as="link"
            href={backLink.href}
            intent="standard"
            size="default"
            iconLeft={IconAngleLeft}
          >
            Terug
          </TextButton>
        ) : (
          <div className="flex flex-row space-x-12 items-center flex-1">
            <PageHeaderTitle
              title={title}
              reference={reference}
              icon={Icon}
              className="flex-1"
              description={description}
              isSpecialLimit={isSpecialLimit}
            />

            {status}
          </div>
        )}

        {actions && <div className="flex flex-row space-x-24">{actions}</div>}
      </div>

      {specs && specs.length > 0 && (
        <div className="flex flex-row space-x-24 items-center">
          {specs.map(({ text, value, icon: SpecIcon }, key) => (
            <PageHeaderSpec
              key={`page-header-spec-${key}`}
              text={text}
              value={value}
              icon={SpecIcon}
            />
          ))}
        </div>
      )}
    </div>
  );
}
